import {
  type Icon,
  IconDeviceDesktop,
  IconInfinity,
  IconLink,
  IconWifiOff,
} from "@tabler/icons-react";

export type Differential = {
  icon: Icon;
  title: string;
  description: string;
  accent: "green" | "orange" | "blue" | "violet" | "teal";
};

export const differentials: Differential[] = [
  {
    icon: IconWifiOff,
    title: "Funciona sem internet",
    description:
      "Ficou sem internet? Sem problema. O sistema roda 100% no seu computador e seus dados ficam guardados ali com você.",
    accent: "green",
  },
  {
    icon: IconDeviceDesktop,
    title: "Roda no PC que você já tem",
    description:
      "Compatível com Windows 10 e 11. Funciona até naquele computador que já passou da idade de aposentar.",
    accent: "green",
  },
  {
    icon: IconLink,
    title: "Tudo num lugar só",
    description:
      "Vendas, estoque, clientes, balanço e relatórios integrados. Você lança uma vez e o sistema cuida do resto.",
    accent: "green",
  },
  {
    icon: IconInfinity,
    title: "É seu pra sempre",
    description:
      "Você compra uma vez e a versão é sua, sem aluguel. Quer novos recursos e melhorias contínuas? O plano de manutenção opcional cuida disso pra você.",
    accent: "green",
  },
];
